'use client'
import { useRouter } from 'next/navigation';
import { MdArrowBackIosNew } from 'react-icons/md'
import tailwindConfig from '@tailwind.config'

export default function BackButton({ title }) {
    const router = useRouter();

    return (
        <button type="button" className='m-0 p-0' onClick={() => router.back()} >
            <div className='flex flex-row items-center m-0 p-0'>
                <MdArrowBackIosNew
                    color={tailwindConfig.theme.extend.colors.secondary}
                    size={14}
                />
                <span className='text-secondary hover:text-maincolor'>{title}</span>

            </div>
        </button>
    );
}